/**
 * The toasts of the pickup points: the operator's panel and the shipment's
 * destination in the order detail. See `feedbackCatalog` for the fields.
 *
 * The forms and dialogs show the refusal where it happened, so their errors
 * are `'none'` here; the menu item that reverts a destination has no surface
 * of its own and keeps the default error toast.
 */
export const PICKUP_POINTS_FEEDBACK_RULES = {
  'pickupPoints/createPickupPoint': {
    success: (action) => `Punto de retiro "${action.payload.name}" creado`,
    error: 'none',
    testId: 'pickup-points-notice',
  },
  'pickupPoints/updatePickupPoint': {
    success: (action) => `Punto de retiro "${action.payload.name}" guardado`,
    error: 'none',
    testId: 'pickup-points-notice',
  },
  'pickupPoints/deletePickupPoint': {
    success: 'Punto de retiro eliminado',
    error: 'none',
    testId: 'pickup-points-notice',
  },
  'orderDetails/redirectToPickupPoint': {
    success: (action) =>
      `Destino cambiado al punto de retiro ${action.payload?.pickup_point?.pickup_point_name || ''}`.trim(),
    error: 'none',
    testId: 'order-pickup-point-notice',
  },
  'orderDetails/revertPickupPoint': {
    success: 'El envío vuelve al domicilio del cliente',
    testId: 'order-pickup-point-notice',
  },
  'orderDetails/handOverAtPickupPoint': {
    success: 'Pedido entregado al cliente en el punto de retiro',
    error: 'none',
    testId: 'order-pickup-point-notice',
  },
};
